import { css } from '@emotion/css'
import { fontFamily } from '../../styles'

const styles = {
  button: css({
    // Override default button styling
    border: 'none',
    background: 'none',
    outline: 'none',
    padding: 0,

    fontFamily: fontFamily.body,
    fontSize: 'inherit',
    fontWeight: 'inherit',
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline',
    },

    '&:focus': {
      textDecoration: 'underline',
    },

    '&:active': {
      textDecoration: 'underline',
    },
  }),

  disabled: css({
    textDecoration: 'none',
    pointerEvents: 'none',
    cursor: 'default',
    opacity: 0.3,
  }),
}

export default styles
